{
  "Accessibility Menu": "অভিগম্যতা মেনু",
  "Reset settings": "নির্ধারণ পুনরায় সেট করুন",
  "Close": "বন্ধ করুন",
  "Content Adjustments": "কন্টেন্ট সংশোধন",
  "Adjust Font Size": "ফন্ট সাইজ সংশোধন",
  "Highlight Title": "শিরোনাম উজ্জ্বল করুন",
  "Highlight Links": "লিঙ্কগুলি উজ্জ্বল করুন",
  "Readable Font": "পঠনীয় ফন্ট",
  "Color Adjustments": "রঙ সংশোধন",
  "Dark Contrast": "অন্ধকারী প্রতিবিম্ব",
  "Light Contrast": "আলোকিত প্রতিবিম্ব",
  "High Contrast": "উচ্চ প্রতিবিম্ব",
  "High Saturation": "উচ্চ সত্রাজন",
  "Low Saturation": "নিম্ন সত্রাজন",
  "Monochrome": "একরঙ",
  "Tools": "সরঞ্জাম",
  "Reading Guide": "পড়ার গাইড",
  "Stop Animations": "অ্যানিমেশন বন্ধ করুন",
  "Big Cursor": "বড় কার্সর",
  "Increase Font Size": "ফন্ট সাইজ বাড়ান",
  "Decrease Font Size": "ফন্ট সাইজ কমান",
  "Letter Spacing": "অক্ষর বিরাটি",
  "Line Height": "লাইন উচ্চতা",
  "Font Weight": "ফন্ট ওজন",
  "Dyslexia Font": "ডাইসলেক্সিয়া ফন্ট",
  "Language": "ভাষা",
  "Open Accessibility Menu": "অভিগম্যতা মেনু খোলুন"
}
